// src/components/forms/SystemIssuesForm.jsx
import { useNavigate } from 'react-router-dom';
import { BugIcon, AlertIcon, ChevronRightIcon } from './shared/FormIcons';
import styles from '../../styles/forms/SharedForm.module.css';
import Breadcrumb from '../shared/Breadcrumb';

const FORM_TYPES = [
  {
    id: 'production-bug',
    title: 'Report a Production Bug',
    description: 'Something is broken in production and needs engineering attention.',
    Icon: BugIcon,
  },
  {
    id: 'system-incident',
    title: 'Log a System Incident',
    description: 'A service is down or critically degraded and impacting users.',
    Icon: AlertIcon,
  },
];

export default function SystemIssuesForm() {
  const navigate = useNavigate();

  const handleSelect = (id) => {
    navigate(`/staff/request/system-issues/${id}`);
  };

  /* ── Selector ── */
  return (
    <div className={styles.wrapper}>
      <Breadcrumb items={[{ label: 'System Issues' }]} />
      <div className={styles.heading}>
        <h1 className={styles.title}>System Issues</h1>
        <p className={styles.sub}>
          Choose the type of system issue you'd like to report.
        </p>
      </div>

      <div className={styles.choices}>
        {FORM_TYPES.map(({ id, title, description, Icon }) => (
          <button
            key={id}
            className={styles.choice}
            onClick={() => handleSelect(id)}
          >
            <div className={styles.choiceIcon}>
              <Icon />
            </div>
            <div className={styles.choiceBody}>
              <p className={styles.choiceTitle}>{title}</p>
              <p className={styles.choiceDesc}>{description}</p>
            </div>
            <span className={styles.choiceArrow}>
              <ChevronRightIcon />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
